import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals, FctValue } from '../../../../Fct/generics';
import { FaPercentage } from 'react-icons/fa';
import { supportedContracts } from '../constants';
export var Mod = createPlugin({
    protocol: 'TOKEN_MATH',
    type: 'CALCULATOR',
    method: 'mod',
    description: 'Modulo amount1 and amount2',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                numerator: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaPercentage }),
                decimals1: new FctDecimals({}),
                amount2: new FctValue({ destination: 'wei_amount', isPreview: true }),
                decimals2: new FctDecimals({}),
                decimalsOut: new FctDecimals({}),
            },
        },
        output: {
            result: new FctValue({
                innerIndex: 0,
            }),
        },
    }); },
});
